//////////////////////////////////
//Auto-generated. Do NOT modify!//
//////////////////////////////////

import { MessageKey, QueryKey, Type, EnumType, registerSymbol } from '../../../Framework/Signum.React/Scripts/Reflection'
import * as Entities from '../../../Framework/Signum.React/Scripts/Signum.Entities'
import * as Authorization from '../Authorization/Signum.Entities.Authorization'


export module OmniboxMessage {
  export const No = new MessageKey("OmniboxMessage", "No");
  export const NotFound = new MessageKey("OmniboxMessage", "NotFound");
  export const Omnibox_DatabaseAccess = new MessageKey("OmniboxMessage", "Omnibox_DatabaseAccess");
  export const Omnibox_Disambiguate = new MessageKey("OmniboxMessage", "Omnibox_Disambiguate");
  export const Omnibox_Field = new MessageKey("OmniboxMessage", "Omnibox_Field");
  export const Omnibox_Help = new MessageKey("OmniboxMessage", "Omnibox_Help");
  export const Omnibox_OmniboxSyntaxGuide = new MessageKey("OmniboxMessage", "Omnibox_OmniboxSyntaxGuide");
  export const Omnibox_MatchingOptions = new MessageKey("OmniboxMessage", "Omnibox_MatchingOptions");
  export const Omnibox_Query = new MessageKey("OmniboxMessage", "Omnibox_Query");
  export const Omnibox_Type = new MessageKey("OmniboxMessage", "Omnibox_Type");
  export const Omnibox_UserChart = new MessageKey("OmniboxMessage", "Omnibox_UserChart");
  export const Omnibox_UserQuery = new MessageKey("OmniboxMessage", "Omnibox_UserQuery");
  export const Omnibox_Dashboard = new MessageKey("OmniboxMessage", "Omnibox_Dashboard");
  export const Omnibox_Value = new MessageKey("OmniboxMessage", "Omnibox_Value");
  export const Unknown = new MessageKey("OmniboxMessage", "Unknown");
  export const Yes = new MessageKey("OmniboxMessage", "Yes");
  export const ComplementWordsRegex = new MessageKey("OmniboxMessage", "ComplementWordsRegex");
  export const Search = new MessageKey("OmniboxMessage", "Search");
}

export module OmniboxPermission {
  export const ViewOmnibox : Authorization.PermissionSymbol = registerSymbol("Permission", "OmniboxPermission.ViewOmnibox");
}


